var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Logged in")]),_c('p',[_vm._v("response from server: "+_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }